export default __webpack_public_path__ + "08fc95b9ae005ac2a2dee651d461f63f.png";